module.exports = "/assets/1978a4231a88466c30d1772785a1c06d.svg";